import { Node } from "@tiptap/core";

export const HardBreakBlock = Node.create({
  name: "hard_break",
  content: "text*",
  group: "inline",
  inline: true,
  renderHTML() {
    return ["br", 0];
  },
});
